import { EBuildingType } from '../types/buildingType';
import { EBuildingTypeLegacy } from '../../api-models/common/json_query';

export const UI_TO_LEGACY_BUILDING_TYPE: Record<EBuildingType, EBuildingTypeLegacy> = {
  [EBuildingType.BusinessCenter]: EBuildingTypeLegacy.BusinessCenter,
  [EBuildingType.House]: EBuildingTypeLegacy.Mansion,
  [EBuildingType.AdministrativeBuilding]: EBuildingTypeLegacy.AdministrativeBuilding,
  [EBuildingType.MultifunctionalComplex]: EBuildingTypeLegacy.MultifunctionalComplex,
  [EBuildingType.Warehouse]: EBuildingTypeLegacy.Warehouse,
  [EBuildingType.FAO]: EBuildingTypeLegacy.FreeAppointmentObject,
  [EBuildingType.Other]: EBuildingTypeLegacy.StandaloneBuilding,
  [EBuildingType.ShoppingCenter]: EBuildingTypeLegacy.ShoppingCenter,
  [EBuildingType.ResidentialBuilding]: EBuildingTypeLegacy.ResidentialHouse,
  [EBuildingType.OfficeBuilding]: EBuildingTypeLegacy.OfficeBuilding,
};

export const LEGACY_TO_UI_BUILDING_TYPE: Partial<Record<EBuildingTypeLegacy, EBuildingType>> = Object.entries(
  UI_TO_LEGACY_BUILDING_TYPE,
).reduce<Partial<Record<EBuildingTypeLegacy, EBuildingType>>>((acc, [ui, legacy]) => {
  acc[legacy] = Number(ui) as EBuildingType;

  return acc;
}, {});
